<template>
  <!-- 特殊設施視窗 -->
  <ui-modal ref="facilitiesModal" :header-title="$t('all_facility')" :forcing="true" :hide-overlay="false" :modal-width="modalWidth">
    <div class="facilities-modal-content d-flex flex-wrap">
      <div v-for="(n, idx) in facilities" :key="idx" class="feature-icon my-2 px-5 py-2 d-flex align-center">
        <v-img :src="facilityImageURL(facilities[idx].icon)" :alt="facilities[idx].name" max-width="32" cover />

        <span class="feature-text ml-5"> {{ facilities[idx].name }} </span>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import UiModal from '@/components/dialog/ui-modal'

import utils from '@/utils'

export default {
  name: 'BranchFacilitiesModal',
  components: {
    UiModal,
  },
  props: {
    items: { type: Array, default: () => [] },
    isMobile: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  computed: {
    modalWidth() {
      return this.isMobile ? '100%' : 712
    },
    facilities() {
      return this.items || []
    },
    ...mapGetters({}),
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    facilityImageURL(icon) {
      return `${utils.CDN}${icon}`
    },
    showModal() {
      this.$refs.facilitiesModal.showModal()
    },
    hideModal() {
      this.$refs.facilitiesModal.hideModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.facilities-modal-content {
  max-height: calc(80vh - 70px);
  padding: 0 20px 24px 32px;
  overflow-y: auto;

  .feature-icon {
    width: 32%;
    max-width: 223px;

    @include xs {
      width: 100%;
    }
  }

  @include xs {
    height: 75vh;
    padding: 0;
    display: block;
  }
}
</style>
